import ReactGA from 'react-ga';

const trackingEnabled = () => !!window.spConfig.gaTrackingId;

const initialize = (testMode?: boolean) => {
  if (!trackingEnabled()) {
    return;
  }

  ReactGA.initialize(window.spConfig.gaTrackingId, { testMode: !!testMode });
};

const logHistoryPageViews = (history: any) => {
  if (!trackingEnabled()) {
    return;
  }

  history.listen((location: any) => {
    const page = location?.pathname || window.location.pathname;
    ReactGA.set({ page: page });
    ReactGA.pageview(page);
  });
};

const logCurrentPageView = () => {
  if (!trackingEnabled()) {
    return;
  }

  ReactGA.pageview(window.location.pathname + window.location.search);
};

/* eslint-enable no-useless-escape */
export { initialize, logHistoryPageViews, logCurrentPageView };
